import useFilters from 'composables/useFilters';
import useCatalogFilters from 'composables/useCatalogFilters';
import Vue from 'vue';
import Component from 'vue-class-component';
import OptionCards from 'components/DynamicFilters/OptionCards/OptionCards.vue';
import Facet from 'components/DynamicFilters/Facet/Facet.vue';
import SearchTags from 'components/DynamicFilters/SearchTags/SearchTags.vue';
import SkeletonFilterColumn from '../SkeletonFilterColumn/SkeletonFilterColumn.vue';

@Component({
  components: {
    OptionCards,
    SearchTags,
    Facet,
    SkeletonFilterColumn,
  },
  props: {
    isBoxCatalog: {
      type: Boolean,
      default: false,
    },
  },
  setup(props) {
    const filterStore = props.isBoxCatalog ? useCatalogFilters() : useFilters();
    const { getFacets, clearCurrentFilters, getLoading, getCurrentTags } =
      filterStore;
    return {
      facetList: getFacets,
      clearCurrentFilters,
      currentTags: getCurrentTags,
      isLoading: getLoading,
    };
  },
})
export default class FilterColumnComponent extends Vue {
  async resetFilters() {
    // At the moment we don't have the feature of manage filters via url, so momentarily i manage only allGiftsMenu category filters via url because it's how it should be
    // So when we reset filters in the store we check if exists route query filters and remove them
    if (this.$route.query.filters) this.$router.push({ query: { card: 0 } });
    await this.clearCurrentFilters({
      clearSharedFilters: true,
      clearDateTime: true,
      refetch: true
    })
    ;
  }
}
